import {
    get_kpi,
    get_andamento,
    get_stagionalita,
    get_clienti,
    get_fasce_importo,
    get_zone,
} from "@/api/api.statistiche.js";

// Il periodo (dal/al, "yyyy-MM-dd" oppure null) è condiviso da tutte le pagine
// di statistiche: cambiandolo, ogni pagina ricarica i propri dati.
// Le actions restituiscono direttamente i dati, senza cache nello state.
const statistiche = {
    namespaced: true,

    state: {
        dal: null,
        al: null,
    },

    mutations: {
        SET_PERIODO: (state, { dal, al }) => {
            state.dal = dal || null
            state.al = al || null
        },
    },

    actions: {
        // periodo: opzionale, sostituisce quello condiviso (es. per l'anno corrente).
        kpi({ getters }, periodo) {
            return get_kpi(periodo || getters.periodo).then(resp => resp.data)
        },

        andamento({ getters }, raggruppa) {
            return get_andamento(getters.periodo, raggruppa).then(resp => resp.data)
        },

        stagionalita({ getters }) {
            return get_stagionalita(getters.periodo).then(resp => resp.data)
        },

        clienti({ getters }, top) {
            return get_clienti(getters.periodo, top).then(resp => resp.data)
        },

        fasceImporto({ getters }) {
            return get_fasce_importo(getters.periodo).then(resp => resp.data)
        },

        zone({ getters }) {
            return get_zone(getters.periodo).then(resp => resp.data)
        },
    },

    getters: {
        // Solo i valori presenti: i parametri null non vanno nella query string.
        periodo: state => {
            const p = {}
            if (state.dal) p.dal = state.dal
            if (state.al) p.al = state.al
            return p
        },
    },
}

export default statistiche
